import { api } from "../api";
import axios from "axios";


export const getReproductions = async () => {
    const res = await axios.get(api + 'reproductions/', {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data'
        }
    });
    return res.data;
}

export const getReproductionById = async (id) => {
    const res = await axios.get(api + 'reproductions/' + id, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data'
        }
    });
    return res.data;
}

export const getReproductionByAnimal = async (id) => {
    const res = await axios.get(api + 'reproductions/animal/' + id, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }
    });
    return res.data;
}

export const getReproductionByAnimalE = async (id) => {
    const res = await axios.get(api + 'reproductionsE/animal/' + id, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }
    });
    return res.data;
}



export const getReproductionsByUser = async (id) => {
    const res = await axios.get(api + "reproductionsE/user/" + id, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            'Content-Type': "application/json",
        },
    });

    return res.data;
};

export const addReproduction = async ({ date_velage, date_saille, date_gestation, date_prevu_velage, description, statusId, animalId }) => {
    const res = await axios.post(api + 'reproductions', {
        date_velage: date_velage,
        date_saille: date_saille,
        date_gestation: date_gestation,
        date_prevu_velage: date_prevu_velage,
        description: description,
        status_id: statusId,
        animal_id: animalId
    }, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }
    });
    return res.data;
}
export const addReproductionE = async ({ date_velage, date_saille, date_gestation, date_prevu_velage, description, statusId, animalId }) => {
    const res = await axios.post(api + 'reproductionsE', {
        date_velage: date_velage,
        date_saille: date_saille,
        date_gestation: date_gestation,
        date_prevu_velage: date_prevu_velage,
        description: description,
        status_id: statusId,
        animal_id: animalId
    }, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }
    });
    return res.data;
}

export const updateReproduction = async (id, data) => {
    const res = await axios.put(api + 'reproductions/' + id, data, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }
    });
    return res.data
}
export const updateReproductionE = async (id, data) => {
    const res = await axios.put(api + 'reproductionsE/' + id, data, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }
    });
    return res.data
}

export const changeReproductionStatus = async (id, status, preserveDates = false) => {
    const url = api + "reproductions/" + id + "/change-status";

    let payload;
    if (status === "previous") {
        payload = { action: "delete" };
    } else {
        payload = {
            action: "update",
            status: status
        };
        if (preserveDates) {
            payload.preserve_dates = true;
        }
    }
    const res = await axios.put(url, payload, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
        },
    });
    return res.data;
};

export const changeReproductionStatusE = async (id, status, preserveDates = false) => {
    const url = api + "reproductionsE/" + id + "/change-status";
    let payload;
    if (status === "previous") {
        payload = { action: "delete" };
    } else {
        payload = {
            action: "update",
            status: status
        };
        if (preserveDates) {
            payload.preserve_dates = true;
        }
    }
    const res = await axios.put(url, payload, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
        },
    });
    return res.data;
};

export const deleteReproduction = async (repId) => {
    await axios.delete(api + 'reproductions/' + repId, {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'multipart/form-data'
        }
    });
}
